import { Container } from "components";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useToaster } from "hooks";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "services/api";
import * as Yup from "yup";

const initialValues = {
  name: "",
  status: "Active",
};

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
});

export const EditCity = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState({ ...initialValues });
  const { setSuccessToaster, setErrorToaster } = useToaster();

  const fetchCityDetails = async () => {
    try {
      const response = await api.get(`/cities/${params.id}`);
      const details = response?.data?.data?.city || response?.data?.data;
      if (details) {
        setData({
          name: details.name || "",
          status: details.status || "Active",
        });
        console.log("city details", details);
      }
    } catch (error) {
      console.log("fetchCityDetails error:", error);
      setErrorToaster("Failed to fetch city details");
    }
  };

  useEffect(() => {
    if (params.id) {
      fetchCityDetails();
    }
  }, [params.id]);

  const handleSubmit = async (values) => {
    try {
      const response = await api.put(`/cities/${params.id}`, values);
      if (response?.status === 200 || response?.status === 201) {
        setSuccessToaster(response?.data?.message || "City updated successfully");
        navigate("/cities");
      }
    } catch (error) {
      console.log("handleSubmit Error:", error);
      setErrorToaster(error?.response?.data?.message || "Failed to update city");
    }
  };

  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/cities">Cities</Link>
              </li>
              <li className="breadcrumb-item active">
                {params?.id ? "Edit" : "Add"} city
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-12">
              <Formik
                initialValues={data}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors }) => {
                  return (
                    <Form>
                      <div className="card mb-4">
                        <h5 className="card-header">
                          {params?.id ? "Edit" : "Add"} city
                        </h5>
                        <hr className="my-0" />
                        <div className="card-body">
                          <div className="row mb-3">
                            <div className="col-md-6 col-12">
                              <label className="form-label">
                                Name <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Name"
                                name="name"
                              />
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-6 col-12">
                              <label className="form-label">
                                Status <span className="invalid-form">*</span>
                              </label>
                              <Field
                                as="select"
                                className="form-select"
                                name="status"
                              >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </Field>
                              <ErrorMessage
                                name="status"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>
                          <button
                            className="btn btn-primary d-grid w-100"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

